import React from 'react';
import type { TextEffectsSharedProps } from '../TextEffectsShared.types';
import {
  formatClassNames,
  getDataAttributes,
  getTabIndexAttribute,
} from '@wix/editor-elements-common-utils';
import { dataHooks, TestIds } from '../constants';
import cx from 'clsx';
import semanticClassNames from '../TextEffectsShared.semanticClassNames';
import Link from '@wix/thunderbolt-elements/components/Link';

const TextEffectsShared: React.FC<
  React.PropsWithChildren<TextEffectsSharedProps>
> = props => {
  const {
    id,
    className,
    customClassNames = [],
    link,
    onMouseEnter,
    onMouseLeave,
    children,
    textDirection,
    isDecorative,
    htmlTag: RootTag = 'div',
    a11y,
  } = props;

  return (
    <RootTag
      {...(isDecorative && { 'aria-hidden': true })}
      id={id}
      data-hook={dataHooks.root}
      className={cx(
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      dir={textDirection}
      {...getDataAttributes(props)}
      {...getTabIndexAttribute(a11y)}
    >
      {link ? (
        <Link {...link} dataTestId={TestIds.viewer.link}>
          {children}
        </Link>
      ) : (
        children
      )}
    </RootTag>
  );
};

export default TextEffectsShared;
